import { NotificationConstants } from "../constants/notification.constant";

let initialState = {
    notificationList : [],
    error : ""
}

export const fetchNotificationList_Reducer = (state = initialState, action) => {
    switch(action.type) {
        case NotificationConstants.GET_NOTIFICATION_LIST_SUCCESS :
            return {
                ...state,
                notificationList : action.payload.data,
            }

        case NotificationConstants.GET_NOTIFICATION_LIST_FAILURE :
            return {
                ...state,
                error : action.payload.data
            }
        default :
            return state;
    }
}
